import { LabelValueLabel, LabelValueRoot, LabelValueValue, Tag } from '@pie/amber';
import { SENSITIVE_CLASS_NAME } from '@upms/analytics';

/**
 * The common "Affected Policy" context tag. Rendered by each platform content
 * component (Zuora/Stripe) so the platform controls where it sits relative to
 * its own content — e.g. Zuora's error banner renders *above* it.
 */
export const AffectedPolicy = ({ policyNumber }: { policyNumber: string }) => (
  <LabelValueRoot>
    <LabelValueLabel>Affected Policy</LabelValueLabel>
    <LabelValueValue>
      <Tag className={SENSITIVE_CLASS_NAME} palette="purple">
        {policyNumber}
      </Tag>
    </LabelValueValue>
  </LabelValueRoot>
);
